import ErrorStatus from '$shared/constants/ErrorStatus';
import Label from '$shared/constants/Label';
import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { ErrorMessage } from '$shared/models/ErrorMessage';
import type { ErrorStatusMapping } from '.';
import { BaseError } from './BaseError';

class CredentialingRequestError extends BaseError {
  constructor() {
    super(Label.CredentialingRequest);
  }

  public attachCredEvent(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToAttachCredRequestEvent),
        true,
        false,
        [UIErrorMessage.CvoSameStatusSelected]
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.MissingPermissionToAttachCredRequestEvent),
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.TryingToAttachCredRequestEventForUnknown),
        true
      )
    };
  }

  public updateChecklist(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.FailedToUpdateChecklist),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.MissingPermissionToUpdateChecklist),
        true
      ),
      [ErrorStatus.NotFound]: ErrorMessage.create(
        this.parseErrorMessage(UIErrorMessage.TryingToUpdateChecklistForUnknowCredRequest),
        true
      )
    };
  }
}

export const credentialingRequestError = new CredentialingRequestError();
